import React, { Component } from 'react';

class UserDataDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            email: '',
            password: '', 
            password2: '',
            farmer_name: '',
            address_city: '',
            address_postcode: '',
            address_street: '',
            address_number: '',
            company_name: '',
            company_number: '',
            farm_size: '',
            farm_cultures: '',
            contact_telephone: '',
            contact_facebook: '',
            companyOrIndividual: 'Individual',
            accepted:false,
            isModification: false,
            errors:{},
            emailAlreadyRegistered: false
         }
    }

    componentDidMount(){
        //console.log("userData", this.props.userData);
        if (this.props.userData){
            let isModification = this.props.isModification ?? true;
            this.setState({...this.props.userData, isModification: isModification, accepted: isModification}, () =>{
                if(this.props.userData.company_name !== ''){
                    this.setState({companyOrIndividual: 'Company'});
                }
            });
        }
    }

    render() { 
        return ( 
            <div id="kwizda-userdata" className="kwizda-form row" style={{width:'100%', margin:'auto'}}>
                <div className="kwizda-form-column col-6 login-card mt-2 hv-center">
                    <div className="card">
                        <h4>Felhasználói fiók</h4>
                        <label>E-mail</label>
                        <input onBlur={(e)=>{this.checkEmail(e)}} className={this.state.errors["email"]?"kwizda-form-invalid":""}
                            type="text" value={this.state.email} disabled={true}
                            name="email" placeholder="E-mail"
                            onChange={(e) => this.setState({[e.target.name]: e.target.value})}></input>
                        <span style={{color: "red"}}>{this.state.errors["email"]}</span>
                        <h4>Név</h4>
                        <input className={this.state.errors["farmer_name"]?"kwizda-form-invalid":""}
                            type="text" value={this.state.farmer_name} name="farmer_name" placeholder="Termelő/kapcsolattartó neve"
                            onChange={(e) => this.setState({[e.target.name]: e.target.value})} disabled={true}></input>
                        <span style={{color: "red"}}>{this.state.errors["farmer_name"]}</span>
                        <h4>Cím</h4>
                        <label>Település</label>
                        <input className={this.state.errors["address_city"]?"kwizda-form-invalid":""}
                            type="text" value={this.state.address_city} name="address_city" placeholder="Település"
                            onChange={(e) => this.setState({[e.target.name]: e.target.value})} disabled={true}></input>
                        <span style={{color: "red"}}>{this.state.errors["address_city"]}</span>
                        <label>Irányítószám</label>
                        <input className={this.state.errors["address_postcode"]?"kwizda-form-invalid":""}
                            type="text" value={this.state.address_postcode} name="address_postcode" placeholder="Irányítószám"
                            onChange={(e) => this.setState({[e.target.name]: e.target.value})} disabled={true}></input>
                        <span style={{color: "red"}}>{this.state.errors["address_postcode"]}</span>
                        <label>Utca</label>
                        <input className={this.state.errors["address_street"]?"kwizda-form-invalid":""}
                            type="text" value={this.state.address_street} name="address_street" placeholder="Utca"
                            onChange={(e) => this.setState({[e.target.name]: e.target.value})} disabled={true}></input>
                        <span style={{color: "red"}}>{this.state.errors["address_street"]}</span>
                        <label>Házszám</label>
                        <input className={this.state.errors["address_number"]?"kwizda-form-invalid":""}
                            type="text" value={this.state.address_number} name="address_number" placeholder="Házszám"
                            onChange={(e) => this.setState({[e.target.name]: e.target.value})} disabled={true}></input>
                        <span style={{color: "red"}}>{this.state.errors["address_number"]}</span>
                    </div>
                </div>
                <div className="kwizda-form-column col-6 login-card mt-2 hv-center">
                    <div className="card">
                        <h4>Elérhetőségek</h4>
                        <label>Telefon</label>
                        <input className={this.state.errors["contact_telephone"]?"kwizda-form-invalid":""}
                            type="text" value={this.state.contact_telephone} name="contact_telephone" placeholder="Telefon"
                            onChange={(e) => this.setState({[e.target.name]: e.target.value})} disabled={true}></input>
                        <span style={{color: "red"}}>{this.state.errors["contact_telephone"]}</span>
                        {(!this.state.isModification)?
                        <div>
                            <h4>Adatvédelmi tájékoztató</h4>
                            <span>
                                <input type="checkbox"
                                onChange={(e) => this.setState({accepted: e.target.checked})}
                                /> Elfogadom a <a href="/szabalyzat" target="_blank"> Részvételi feltételeket és az Adatvédelmi Tájékoztatót</a>
                            </span>
                        </div>:""
                        }
                        
                    </div>
                </div>
            </div> 
        );
    }
   
}
 
export default UserDataDisplay;